import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

const ErrorHandle = ({ children }: any) => {
    const is_error_occurred = useSelector(
        (state: any) => state?.items?.is_error_occured
    );
    useEffect(() => {
        if (is_error_occurred) {
            const reloadTimer = setTimeout(() => {
                window.location.reload();
            }, 1000);
            return () => clearTimeout(reloadTimer);
        }
    }, [is_error_occurred]);

    console.log(is_error_occurred, "is error occurred");

    return (
        <>
            {!is_error_occurred ? (
                children
            ) : (
                <div className="v-100 d-flex align-item-center justify-content-center">
                    <Spinner size="sm" className="me-2" />
                    Loading..</div>
            )}
        </>
    );
};

export default ErrorHandle;
